// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:21
import { CrisisCallCard_abstract } from './../abstract/SagaSchema/CrisisCallCard_abstract';
export class CrisisCallCard extends CrisisCallCard_abstract {}
